import React, { useState, useEffect } from 'react';
import { Button, Table, Modal, Form, Alert } from 'react-bootstrap';
import axios from 'axios';

const ProductDeals = () => {
  const [deals, setDeals] = useState([]);
  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState({
    deal_title: '',
    deal_desc: '',
    image: null,
    deal_discount: ''
  });
  const [editId, setEditId] = useState(null);
  const [error, setError] = useState(null);
  const [imagePath, setImagePath] = useState('');
  const [imagePreview, setImagePreview] = useState(null); // State for image preview

  useEffect(() => {
    fetchDeals();
  }, []);

  const fetchDeals = async () => {
    try {
      const response = await axios.get('https://drdprints.com/api/get-productdeals');
      console.log(response.data); // Debug the response structure
      const data = response.data.productdeals || [];
      setDeals(data);
      setImagePath(response.data.imagePath);
    } catch (error) {
      console.error('Error fetching deals:', error);
    }
  };

  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
    setEditId(null);
    setFormData({
      deal_title: '',
      deal_desc: '',
      image: null,
      deal_discount: ''
    });
    setImagePreview(null); // Clear the image preview on modal close
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'image') {
      const file = files[0];
      setFormData({ ...formData, image: file });

      // Generate a preview URL for the selected image
      setImagePreview(file ? URL.createObjectURL(file) : null);
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const url = editId
        ? `https://drdprints.com/api/update-productdeal/${editId}`
        : 'https://drdprints.com/api/store-productdeal';
    const method = editId ? 'POST' : 'POST'; // Use POST to work with form data for both create and update

    const formDataToSend = new FormData();
    formDataToSend.append('deal_title', formData.deal_title);
    formDataToSend.append('deal_desc', formData.deal_desc);
    formDataToSend.append('deal_discount', formData.deal_discount);

    if (formData.image) {
        formDataToSend.append('image', formData.image);
    }

    try {
        const response = await axios({
            method,
            url,
            data: formDataToSend,
            headers: { 'Content-Type': 'multipart/form-data' }
        });

        if (response.data.status === 200) {
            fetchDeals();
            handleClose();
        } else {
            setError('Failed to save the deal. Please try again.');
            console.error('Backend errors:', response.data.errors); // Log backend errors for debugging
        }
    } catch (error) {
        setError('Error submitting the form. Please check the fields.');
        console.error('Error details:', error.response || error.message);
    }
  };


  const handleEdit = (deal) => {
    setEditId(deal.id);
    setFormData({
      deal_title: deal.deal_title,
      deal_desc: deal.deal_desc,
      image: null,
      deal_discount: deal.deal_discount
    });
    setImagePreview(null); // Reset image preview when editing a deal
    handleShow();
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://drdprints.com/api/deleteproductdeal/${id}`);
      fetchDeals();
    } catch (error) {
      console.error('Error deleting deal:', error);
    }
  };

  return (
    <div className="container mt-5">
      <h1 className="mb-4">Product Deals</h1>
      <Button variant="primary" onClick={handleShow}>
        Add New Deal
      </Button>
      <Table striped bordered hover className="mt-4">
        <thead>
          <tr>
            <th>#</th>
            <th>Title</th>
            <th>Description</th>
            <th>Discount</th>
            <th>Image</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {deals.map((deal, index) => (
            <tr key={deal.id}>
              <td>{index + 1}</td>
              <td>{deal.deal_title}</td>
              <td>{deal.deal_desc}</td>
              <td>{deal.deal_discount}%</td>
              <td>
                {deal.deal_image ? (
                  <img
                    src={`${imagePath}/${deal.deal_image}`}
                    alt={deal.deal_title}
                    style={{ width: '100px' }}
                  />
                ) : (
                  'No Image'
                )}
              </td>
              <td>
                <Button variant="warning" className='mb-2' onClick={() => handleEdit(deal)}>
                  Edit
                </Button>{' '}
                <Button variant="danger" onClick={() => handleDelete(deal.id)}>
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{editId ? 'Edit Deal' : 'Add New Deal'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formDealTitle">
              <Form.Label>Deal Title</Form.Label>
              <Form.Control
                type="text"
                name="deal_title"
                value={formData.deal_title}
                onChange={handleChange}
                placeholder="Enter deal title"
                required
              />
            </Form.Group>
            <Form.Group controlId="formDealDesc" className="mt-3">
              <Form.Label>Deal Description</Form.Label>
              <Form.Control
                as="textarea"
                name="deal_desc"
                value={formData.deal_desc}
                onChange={handleChange}
                placeholder="Enter deal description"
                rows={3}
                required
              />
            </Form.Group>
            <Form.Group controlId="formDiscount" className="mt-3">
              <Form.Label>Discount (%)</Form.Label>
              <Form.Control
                type="number"
                name="deal_discount"
                value={formData.deal_discount}
                onChange={handleChange}
                placeholder="Enter discount"
                required
              />
            </Form.Group>
            <Form.Group controlId="formImage" className="mt-3">
              <Form.Label>Image</Form.Label>
              <Form.Control type="file" name="image" onChange={handleChange} />
              {imagePreview && (
                <img
                  src={imagePreview}
                  alt="Preview"
                  className="mt-3"
                  style={{ width: '100%', maxHeight: '200px' }}
                />
              )}
            </Form.Group>
            <Button variant="primary" type="submit" className="mt-4">
              {editId ? 'Update Deal' : 'Add Deal'}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ProductDeals;
